// Αποθήκευση αρχείου που ήρθε ως blob (το αίτημα θέλει Authorization, οπότε
// δεν γίνεται απλός σύνδεσμος). Χωριστά από το services/api (που φορτώνει το axios),
// ώστε να το παίρνουν και σελίδες με fetch — και τα tests τους — χωρίς το axios.
export const saveBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
